const utils = require('../utils/Utils');
const ScrollHelper = require('../helpers/ScrollHelper');

function Validations() {
	this.$parent = '.form-group';

	this.$input = $(
		'.form-group__input input, .form-group__input textarea, .subscription__input._check'
	);
	this.$input.on('input change', function(e) {
		const val = $(this).val();
		if (val.length) {
			$(this).addClass('_val');
		} else {
			$(this).removeClass('_val');
		}
	});

	this.filesExt = ['pdf', 'png', 'jpg', 'jpeg'];
	this.fileMaxSize = 1024 * 1024 * 1024 * 2;
	var self = this;

	$('input[type="file"]').on('change', function() {
		const val = $(this)
			.val()
			.split(/(\\|\/)/g)
			.pop();
		const size = this.files[0].size;
		const checkFile = self.checkFile(val, size);

		const $parent = $(this).closest('.form-group');
		const $btn = $(this).closest('.form__btn');

		if (checkFile) {
			$parent.removeClass('_error');
			$btn.addClass('_ready');
			const $input = $(this).data('input');
			const $text = $parent.find('[data-for-input="' + $input + '"]');
			if (val !== '') {
				$text.text(val);
				$(this).addClass('_val');
			} else {
				$text.text('');
				$(this).removeClass('_val');
			}
		} else {
			$parent.addClass('_error');
			$btn.removeClass('_ready');
		}
	});

	$('[data-required]').on('focusout', function() {
		var $this = $(this);
		var val = $this.val();
		var $parent = $this.closest('.form-input');
		var $helpIcon = $parent.find('.form-input__error');

		if (val.length == 0) {
			$parent.addClass('_error');
		} else {
			$parent.removeClass('_error');
		}
	});

	$('[data-form-validation]').on('submit', e => {
		e.preventDefault();
		const $form = $(e.currentTarget);
		const willSubmit = this.test($form);
		willSubmit ? this.send($form) : ScrollHelper.scrollTo($form.find('.form-group._error').eq(0));
	});

	$('[data-form-with-doc]').on('beforeSend', (e, formData) => {
		const $form = $(e.currentTarget);
		const $input = $form.find('input[type="file"]')[0];
		const files = $input.files;
		if (files.length) {
			formData.append('screen', files[0]);
		}
	});
}

Validations.prototype = {
	checkFile: function(val, size) {
		var checkFile;
		var parts = val.split('.');
		var checkType = this.filesExt.join().search(parts[parts.length - 1]);
		var checkSize = size <= this.fileMaxSize;
		if (checkType != -1 && checkSize) {
			checkFile = true;
		} else {
			checkFile = false;
		}
		return checkFile;
	},
	isEmail: function(string) {
		/* eslint-disable-next-line  */
		const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(string);
	},
	isPhone: function(string) {
		/* eslint-disable-next-line  */
		const re = /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/;
		return re.test(string);
	},
	testInput: function($input) {
		$input.parent(this.$parent).removeClass('_error');

		var isRequired = typeof $input.attr('data-required') != 'undefined';
		if (!isRequired) {
			return true;
		}

		var joinAttribute = $input.attr('data-join-input');
		var hasJoin = false;
		var joinOk = false;

		var value = $.trim($input.val());

		if (typeof joinAttribute != 'undefined') {
			hasJoin = true;

			var $joinElements = $('[data-join-input="' + joinAttribute + '"]');
			var totalJoinElements = $joinElements.length;
			var hasAnyValue = false;
			for (var k = 0; k < totalJoinElements; k++) {
				var $joinElement = $joinElements.eq(k);
				var joinValue = $joinElement.val();
				if (joinValue.length && $.trim(joinValue) != '') {
					hasAnyValue = true;
				}
			}
			if (!hasAnyValue) {
				// console.log($joinElements.length)
				$joinElements.addClass('_error');
				return false;
			}
			joinOk = true;
		} else {
			if (value.length == 0) {
				$input.closest(this.$parent).addClass('_error');
				return false;
			}
		}

		var isEmail = typeof $input.attr('data-email') != 'undefined';
		if (isEmail) {
			if (value == '' && joinOk && hasJoin) {
				return true;
			}
			if (!this.isEmail(value)) {
				$input.parent(this.$parent).addClass('_error');
				return false;
			} else {
				return true;
			}
		}

		var isPhone = typeof $input.attr('data-phone') != 'undefined';
		if (isPhone) {
			if (value == '' && joinOk && hasJoin) {
				return true;
			}
			var testPhone = this.isPhone(value);
			if (!this.isPhone(value) || !testPhone) {
				$input.parent(this.$parent).addClass('_error');
				return false;
			} else {
				return true;
			}
		}
	},
	testSelected: function($selected) {
		$selected.removeClass('_error');
		var value = $.trim($selected.find('.i-select__input').val());
		if (value.length == 0) {
			$selected.addClass('_error');
			return false;
		}
	},
	testCheck: function($checkbox) {
		$checkbox.closest('.form-group').removeClass('_error');

		var isRequired =
			typeof $checkbox.find('.i-checkbox__input').attr('data-required') != 'undefined';
		if (!isRequired) {
			return true;
		}

		var value = $checkbox.find('.i-checkbox__input').prop('checked');
		if (!value) {
			$checkbox.closest('.form-group').addClass('_error');
			return false;
		}
	},
	test: function($form) {
		const $inputs = $form.find('input, textarea');
		var willSubmit = true;
		var totalInputs = $inputs.length;
		for (let k = 0; k < totalInputs; k++) {
			var inputCheck = this.testInput($inputs.eq(k));
			if (inputCheck == false) {
				willSubmit = false;
			}
		}
		var $selected = $form.find('.i-select');
		var totalSelected = $selected.length;
		for (let k = 0; k < totalSelected; k++) {
			var selectedCheck = this.testSelected($selected.eq(k));
			if (selectedCheck == false) {
				willSubmit = false;
			}
		}
		var $checkbox = $form.find('.i-checkbox');
		var totalChecbox = $checkbox.length;
		for (let k = 0; k < totalChecbox; k++) {
			var checkboxCheck = this.testCheck($checkbox.eq(k));
			if (checkboxCheck == false) {
				willSubmit = false;
			}
		}
		return willSubmit;

		//if (willSubmit) {
		//	this.send($form, $data);
		//} else {
		//	ScrollHelper.scrollTo($form);
		//}
	},
	error($form) {
		ScrollHelper.scrollTo($form);
	},
	send($form) {
		let action = $form.attr('action');
		if (!action || action == '') {
			console.error('No form action attribute!');
			return;
		}

		$form.addClass('_loading');

		let formData = new FormData($form[0]);

		$form.trigger('beforeSend', [formData]);

		let $formSubmited = $form.find('[data-form-submit]');
		let $formComplete = $form.find('[data-form-complete]');
		let $formError = $form.find('[data-form-error]');
		console.log($formSubmited, $formComplete);

		let request = new XMLHttpRequest();
		request.open('POST', action, true);
		request.onload = function() {
			$form.removeClass('_loading');
			if (request.status == 200) {
				if ($formComplete.length) {
					$formSubmited.hide();
					$formComplete.slideDown();
					$form.addClass('_submited');
				} else {
					console.log('Форма отправлена');
				}
			} else {
				if ($formError.length) {
					$formSubmited.hide();
					$formError.slideDown();
				} else {
					console.log('Ошибка', request);
				}
			}
			console.log(request.response);
		};

		request.send(formData);
	},
};

module.exports = new Validations();
